import type { Category } from '@lapo/core';

/**
 * Client side of the Library categories (browse-by-topic). The server computes the category blocks
 * on a schedule and lazily on read (see server-api categories/service.ts); this just fetches the
 * cached set over `GET /categories`. Returns [] when the API/token is unconfigured or on any error,
 * so the Library degrades gracefully to a plain document list offline. userId is taken server-side
 * from the token, never sent by the client.
 */
const API_URL = import.meta.env.VITE_API_URL;

export async function fetchCategories(token: string | null, signal?: AbortSignal): Promise<Category[]> {
  if (!API_URL || !token) return [];
  try {
    const res = await fetch(`${API_URL}/categories`, {
      headers: { authorization: `Bearer ${token}` },
      signal,
    });
    if (!res.ok) return [];
    const body = (await res.json()) as { categories?: Category[] };
    return body.categories ?? [];
  } catch {
    return []; // offline / not configured → no category blocks, just the list
  }
}
